namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem5Row {
        Id?: number;
        PmId?: string;
        PmType?: number;
        PmGroupId?: string;
        PmExtCode?: string;
        PmDesc?: string;
        PmStepNo?: number;
        PmOrder?: number;
        LineItemNo?: number;
        ItemType?: number;
        AssortFg?: number;
        ListFg?: number;
        PluCode?: string;
        StyleCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        SupplCode?: string;
        Qty?: number;
        Amt?: number;
        FreeLpFg?: number;
        FreeQty?: number;
        LpPrice?: number;
        NpcsOrBundlePrice?: number;
        DiscPc?: number;
        DiscAmt?: number;
        Price1?: number;
        Price2?: number;
        Price3?: number;
        Price4?: number;
        DiscPc1?: number;
        DiscPc2?: number;
        DiscPc3?: number;
        DiscPc4?: number;
        BundleItemNo?: number;
        BuncleQty?: number;
        BundleUnitPrice?: number;
        BundleExPrice?: number;
        EndBillPmType?: number;
        CouponType?: string;
        CouponAgeDay?: number;
        CouponGiftDesc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace PsAdvPromoItem5Row {
        export const idProperty = 'Id';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.PsAdvPromoItem5';
        export const lookupKey = 'AdvPromo.PsAdvPromoItem5';

        export function getLookup(): Q.Lookup<PsAdvPromoItem5Row> {
            return Q.getLookup<PsAdvPromoItem5Row>('AdvPromo.PsAdvPromoItem5');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmId = "PmId",
            PmType = "PmType",
            PmGroupId = "PmGroupId",
            PmExtCode = "PmExtCode",
            PmDesc = "PmDesc",
            PmStepNo = "PmStepNo",
            PmOrder = "PmOrder",
            LineItemNo = "LineItemNo",
            ItemType = "ItemType",
            AssortFg = "AssortFg",
            ListFg = "ListFg",
            PluCode = "PluCode",
            StyleCode = "StyleCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            SupplCode = "SupplCode",
            Qty = "Qty",
            Amt = "Amt",
            FreeLpFg = "FreeLpFg",
            FreeQty = "FreeQty",
            LpPrice = "LpPrice",
            NpcsOrBundlePrice = "NpcsOrBundlePrice",
            DiscPc = "DiscPc",
            DiscAmt = "DiscAmt",
            Price1 = "Price1",
            Price2 = "Price2",
            Price3 = "Price3",
            Price4 = "Price4",
            DiscPc1 = "DiscPc1",
            DiscPc2 = "DiscPc2",
            DiscPc3 = "DiscPc3",
            DiscPc4 = "DiscPc4",
            BundleItemNo = "BundleItemNo",
            BuncleQty = "BuncleQty",
            BundleUnitPrice = "BundleUnitPrice",
            BundleExPrice = "BundleExPrice",
            EndBillPmType = "EndBillPmType",
            CouponType = "CouponType",
            CouponAgeDay = "CouponAgeDay",
            CouponGiftDesc = "CouponGiftDesc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
